import React from 'react';
import { Link } from 'react-router-dom';
import '../Layout/shell.css';
import '../../pages/coming-soon.css';

/** Zárt bolt mód: minimális keret (logó + jogi linkek) a „Hamarosan” oldalhoz és a zárt
 *  boltban is elérhető oldalakhoz (bejelentkezés, jelszó, ÁSZF …) — bolti fejléc nélkül. */
const ClosedShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="gtsoon">
    <header className="gtsoon-top">
      <Link className="gtsoon-brand" to="/">
        <img src="/brand/logo-mark.svg" alt="" />
        <div>
          <b>Kreatív Sarok</b>
          <span>Egyedi nyomat</span>
        </div>
      </Link>
    </header>
    <main className="gtsoon-main">{children}</main>
    <footer className="gtsoon-foot">
      <Link to="/aszf">ÁSZF</Link>
      <Link to="/adatvedelem">Adatvédelem</Link>
      <Link to="/rendeles-kovetese">Rendeléskövetés</Link>
    </footer>
  </div>
);

export default ClosedShell;
